import get from 'lodash/get'
import { render } from 'react-dom'
import React from 'react'
import { select, mouse as d3mouse, event as d3event } from 'd3-selection'
import { drag } from 'd3-drag'
import EmployeeDragPreview from '../../AdminFloorPlan/EmployeeDragPreview'
import findSpaceByCoordinates from './findSpaceByCoordinates'
import findNeighborhoodByCoordinates from './findNeighborhoodByCoordinates'
import { isPrimary, isShared, isSecondary } from '@utils'
class EmployeeDrag {
  constructor(map) {
    this.map = map
    this.space = null // drag source
    this.toSpace = null // drag target

    select(map.container.node()).call(
      drag()
        .clickDistance(100)
        .on('start', () => this.onDragstart())
        .on('drag', () => this.onDrag())
        .on('end', () => this.onDragend())
    )
  }

  update = (map) => {
    this.map = map
  }

  onDragstart = () => {
    if (d3event.sourceEvent.srcElement.id !== 'floorImage') return
    const { map } = this
    const mouse = d3mouse(map.container.node())
    map.tooltip.hideTooltip()
    this.space = findSpaceByCoordinates(mouse, map)
    map.updateDraggedItemAndTarget(this.space, null)
  }

  onDrag = () => {
    // Completely disabling dragging for seats that are not primary
    if (!this.space || !isPrimary(this.space.usageType)) {
      return
    }
    const { map } = this
    const mouse = d3mouse(map.container.node())
    const toSpace = findSpaceByCoordinates(mouse, map)

    if (
      (!toSpace || get(toSpace, 'spaceAssignment.neighborhood')) &&
      map.areas &&
      map.showNeighborhoodsArea
    ) {
      const nh = findNeighborhoodByCoordinates(mouse, map)
      if (nh) {
        this.toSpace = null
        this.nh = nh
      } else {
        this.toSpace = null
        this.nh = null
      }
    } else if (!toSpace) {
      this.toSpace = null
      this.nh = null
    } else if (get(this.space, 'id') !== get(toSpace, 'id')) {
      this.toSpace = toSpace
      this.nh = null
    }
    !map.unseatZone.visible() && map.unseatZone.show()
    map.updateDraggedItemAndTarget(this.space, this.toSpace, this.nh)
    this.draw(mouse)
  }

  onDragend = () => {
    const { map, space, toSpace, nh } = this
    const employee = get(space, 'spaceAssignment.employee')

    if (nh || get(toSpace, 'spaceAssignment.neighborhood')) {
      map.actions.dragEmployeeToNeighborhood(nh, toSpace, space)
    } else if (space && toSpace && space.id !== toSpace.id) {
      if (
        isPrimary(toSpace.usageType) ||
        isSecondary(toSpace.usageType) ||
        isShared(toSpace.usageType)
      ) {
        map.actions.seatEmployee(employee, toSpace)

        // map.actions.reseatEmployee(toSpace.id, space.id, {
        //   ...employee,
        //   dept: space.spaceAssignment.department,
        //   team: space.spaceAssignment.team,
        // })
      }
    }
    if (map.unseatZone.isOver()) {
      map?.actions?.unseatEmployee(employee)
    }

    this.space = null
    this.toSpace = null
    map.unseatZone.hide()
    map.updateDraggedItemAndTarget(null, null)

    render(<div />, map.dragPreviewContainer)
  }

  draw = ([x, y]) => {
    const { space, map } = this
    const employee = get(space, 'spaceAssignment.employee')

    render(
      employee ? (
        <div
          style={{
            zIndex: 1000,
            pointerEvents: 'none',
            position: 'fixed',
            top: `${y + 140}px`,
            left: `${x + 65}px`,
          }}
        >
          <EmployeeDragPreview employee={employee} />
        </div>
      ) : null,
      map.dragPreviewContainer
    )
  }
}

export default EmployeeDrag
